// extracted by mini-css-extract-plugin
export default {"fixed":"Erreur404_fixed__friM-","container":"Erreur404_container__yZFoX"};